module.exports = __webpack_public_path__ + "@/assets/img/attachment.891fb80c.svg";